<input
[(ngModel)]="value" 
#searchInput 
class="search-bar" 
type="text"
name="{{name}}" 
placeholder="{{placeholder | translate}}"
autocomplete="off" 
(blur)="blur()" 
(input)="blur()"
[ngStyle]="{'max-width.px': maxwidth, 'height.px': height}">